import CompDetailsScreen from "@/screens/analyze/CompDetailsScreen"

export default CompDetailsScreen
